export default __webpack_public_path__ + "static/media/lifebelt.a1fcb45c.svg";